<div class="scene-stage" aria-hidden="true">
  <svg class="scene-map" viewBox="0 0 1200 800" preserveAspectRatio="xMidYMid slice" focusable="false">
    <image class="scene-image" href="/assets/images/background/world_map.jpg" x="0" y="0" width="1200" height="800"></image>
    @for (s of shapes; track s.id) {
      <g class="shape" [attr.data-shape]="s.id">
        @if (s.kind === 'area') {
          <polygon class="shape-fill" [attr.points]="s.points"></polygon>
          <polygon class="shape-line" [attr.points]="s.points" pathLength="1"></polygon>
        } @else {
          <polyline class="shape-line shape-distance" [attr.points]="s.points" pathLength="1"></polyline>
        }
        @for (v of s.vertices; track $index) {
          <circle class="shape-vertex" [attr.cx]="v.x" [attr.cy]="v.y" r="3.4"
                  [style.animation-delay.ms]="v.at * drawMs"></circle>
        }
        <foreignObject [attr.x]="s.label.x - 160" [attr.y]="s.label.y - 60" width="320" height="120">
          <div class="label-wrap">
            <div class="label">
              <div class="label-name">{{strings[s.nameKey]}}</div>
              @if (s.kind === 'area') {
                <div class="label-row"><span class="label-key label-area">a:</span><span data-count="area"></span> km²</div>
                <div class="label-row"><span class="label-key label-perimeter">p:</span><span data-count="perimeter"></span> km</div>
              } @else {
                <div class="label-row"><span class="label-key label-perimeter">d:</span><span data-count="perimeter"></span> km</div>
              }
            </div>
          </div>
        </foreignObject>
      </g>
    }
  </svg>
</div>
<div class="scene-shade" aria-hidden="true"></div>

<a class="scene-brand" href="https://measuremaponline.com" [attr.aria-label]="strings['login_back_to_website']">
  <img src="/assets/images/app-logo.svg" alt="" width="40" height="35">
  <span>{{strings['app_name']}}</span>
</a>

<div class="scene-copy">
  <p class="scene-headline">{{strings['login_scene_headline']}}</p>
  <p class="scene-text">{{strings['login_scene_text']}}</p>
</div>
